'use strict';

angular.module('chatEngine.filters', ['chatEngine.configuration'])

.filter('toArray', function() {
    return function(obj) {
        if (!(obj instanceof Object)) {
            return obj;
        }

        return Object.keys(obj).map(function(key) {
            return obj[key];
        });
    };
})

.filter('tosString', ['TOS_MAP', function(TOS_MAP) {
    return function(input) {
        return TOS_MAP[input];
    };
}])

.filter('profilePicUrlHttpToHttps', ['PROFILE_PIC_URL_PREFIXES', function(PROFILE_PIC_URL_PREFIXES) {
    return function(input) {
        if (input.indexOf(PROFILE_PIC_URL_PREFIXES.HTTP_CF) === 0) {
            return PROFILE_PIC_URL_PREFIXES.HTTPS +
                input.substring(PROFILE_PIC_URL_PREFIXES.HTTP_CF.length, input.length);
        }
        if (input.indexOf(PROFILE_PIC_URL_PREFIXES.HTTP_BARE) === 0) {
            return PROFILE_PIC_URL_PREFIXES.HTTPS +
                input.substring(PROFILE_PIC_URL_PREFIXES.HTTP_BARE.length, input.length);
        }
        return input;
    };
}])

.filter('nl2br', ['$sce', function($sce) {
    // https://gist.github.com/naoyeye/8220054
    var breakTag = '<br />';
    return function(s) {
        if(!s) {
            return s;
        }

        s = s.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        return $sce.trustAsHtml(s);
    };
}]);
